/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Base from 'linced-enrolments/routes/base';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class ApplyRoute extends Base {
  queryParams = {
    previewSchemaId: {
      as: 'preview',
    },
  };

  // Services
  @service
  router;

  @service
  store;

  // Route state
  // Stores the countryCode as a param in order to transition to a country
  // selection.
  @tracked
  countryCode = '';

  // needs to be pushed down due to ember-paper-stepper pushes state into the
  // controller.
  currentStep = 0;

  //// Model State
  // schema contains the enrolment form field schema
  @tracked
  schema = null;

  // applicationRecord contains the form field data to apply to enrol.
  @tracked
  applicationRecord = null;

  model({ country_code, school_code }) {
    // The backend stores the country code in upper case and compares it exactly.
    const countryCode = country_code.toUpperCase();
    this.countryCode = countryCode;

    return this.store.query('enrolments/schema', {
      countryCode,
      schoolCode: school_code,
    });
  }

  setupController(controller, model) {
    // Call _super for default behavior
    super.setupController(controller, model);

    // Extract schema object or redirect to not found.
    if (isEmpty(model)) {
      this.router.transitionTo('school-not-found');
      return;
    }

    // Bind in the enrolment schema
    this.schema = model.at(0);

    // Create a new application to bind the schema data into.
    let props = this.schema.getProperties(
      'enrolmentYear',
      'countryCode',
      'schoolCode',
      'campusCode',
      'schoolId',
      'campusId',
      'jurisdiction',
    );
    let applicationRecord = this.store.createRecord(
      'enrolments/application',
      props,
    );

    // Initialise contact fragments
    if (!isEmpty(this.schema.primaryContacts)) {
      for (let i = 0; i < this.schema.get('primaryContacts.count'); i++) {
        applicationRecord.contacts.createFragment({
          type: 1, // Primary contact
        });
      }
    }
    if (!isEmpty(this.schema.emergencyContacts)) {
      for (let i = 0; i < this.schema.get('emergencyContacts.count'); i++) {
        applicationRecord.contacts.createFragment({
          type: 4, // Emergency contact
        });
      }
    }
    if (!isEmpty(this.schema.medicalContacts)) {
      for (let i = 0; i < this.schema.get('medicalContacts.count'); i++) {
        applicationRecord.medicalContacts.createFragment({});
      }
    }
    if (!isEmpty(this.schema.medicalConditions)) {
      for (let i = 0; i < this.schema.get('medicalConditions.count'); i++) {
        applicationRecord.medicalConditions.createFragment({});
      }
    }

    // Bind applicationRecord into state
    this.applicationRecord = applicationRecord;

    // currently ember-paper-stepper is pushing its state into the controller
    // and needs to be manually overridden.
    controller.set('currentStep', this.currentStep);
    controller.setProperties(
      this.getProperties(
        'countryCode',
        'currentStep',
        'schema',
        'applicationRecord',
      ),
    );
  }
}
